module.exports = __webpack_public_path__ + "static/media/info_ad.9fb55e37.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Images/ManualCall/info_ad.svg
// module id = 1805
// module chunks = 0